import { Box, Button, Stack, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

function EcoEmptyShortcut({ icon, title, description, to, buttonLabel, onClick }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const displayTitle = title || t('dashboard.emptyTitle') // LAP-733 (GE022)
  return (
    <Stack
      className="no-drag"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      spacing={1.5}
      sx={{
        height: '100%',
        minHeight: 260,
        px: 2,
        color: 'white',
      }}
    >
      <Box
        sx={{
          width: 58,
          height: 58,
          borderRadius: 2,
          display: 'grid',
          placeItems: 'center',
          bgcolor: 'rgba(255, 255, 255, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.16)',
          color: '#c1daf1',
        }}
      >
        {icon}
      </Box>
      <Typography sx={{ fontWeight: 850, fontSize: 19, lineHeight: 1.2 }}>{displayTitle}</Typography>
      <Typography sx={{ maxWidth: 340, color: 'rgba(255, 255, 255, 0.72)', fontSize: 13.5 }}>
        {description}
      </Typography>
      <Button
        component={to ? RouterLink : 'button'}
        to={to}
        onClick={onClick}
        variant="contained"
        endIcon={<ArrowForwardIcon />}
        sx={{
          mt: 1,
          bgcolor: '#1b75d0',
          borderRadius: 999,
          px: 2.4,
          py: 0.8,
          fontWeight: 800,
          textTransform: 'none',
          whiteSpace: 'normal',
          lineHeight: 1.2,
          '&:hover': { bgcolor: '#145da8' },
        }}
      >
        {buttonLabel}
      </Button>
    </Stack>
  )
}

export default EcoEmptyShortcut
